import * as Preact from "preact"
import * as PlotSteps from "@frog/source/data/plot/steps.js"

import items from "@frog/source/data/games/dice/data/items.jsx"

export default {
    "affiliation": "good",
    "rollcount": 3,
    "party": {
        "units": {
            "dog": {
                "key": "dog",
                "title": "The Pawladin",
                "affiliation": "good",
                "isRecruited": true,

                "maxhealth": 60,
                "moverange": 2,

                "diceFaces": {
                    "0": {...items["burning-blade"], "power": 20},
                    "1": {...items["burning-blade"], "power": 20},
                    "2": {...items["burning-blade"], "power": 30},
                    "3": {...items["earthen-hammer"], "power": 10},
                    "4": {...items["earthen-hammer"], "power": 10},
                    "5": {...items["earthen-hammer"], "power": 20},
                },
                // "diceFaces": {
                //     "0": {
                //         ...items["tomahawk"],
                //     },
                // },
                // "diceFaces": {
                //     "0": {"title": "Burning Blade", "description": "Attack for **N** Fire Damage", "icon": require("@frog/source/assets/images/dice-tactics/actions/shard-sword.png"), "element": "fire", "skillKeys": ["inflict-damage"], "attackrange": 1, "power": 0},
                //     "1": {"title": "Burning Blade", "description": "Attack for **N** Fire Damage", "icon": require("@frog/source/assets/images/dice-tactics/actions/shard-sword.png"), "element": "fire", "skillKeys": ["inflict-damage"], "attackrange": 1, "power": 10},
                //     "2": {"title": "Burning Blade", "description": "Attack for **N** Fire Damage", "icon": require("@frog/source/assets/images/dice-tactics/actions/shard-sword.png"), "element": "fire", "skillKeys": ["inflict-damage"], "attackrange": 1, "power": 20},
                //     "3": {"title": "Burning Blade", "description": "Attack for **N** Fire Damage", "icon": require("@frog/source/assets/images/dice-tactics/actions/shard-sword.png"), "element": "fire", "skillKeys": ["inflict-damage"], "attackrange": 1, "power": 30},
                //     "4": {"title": "Burning Blade", "description": "Attack for **N** Fire Damage", "icon": require("@frog/source/assets/images/dice-tactics/actions/shard-sword.png"), "element": "fire", "skillKeys": ["inflict-damage"], "attackrange": 1, "power": 40},
                //     "5": {"title": "Burning Blade", "description": "Attack for **N** Fire Damage", "icon": require("@frog/source/assets/images/dice-tactics/actions/shard-sword.png"), "element": "fire", "skillKeys": ["inflict-damage"], "attackrange": 1, "power": 50},
                // },

                "scripts": {
                    "death": [
                        // ...
                    ]
                },

                "stack": 1,
                "spriteSize": "4x3",
                "sprites": {
                    "idle": {
                        "frames": [
                            {"time": 0.000, "image": require("@frog/source/assets/images/dice-tactics/dog1.png")},
                            {"time": 125*1, "image": require("@frog/source/assets/images/dice-tactics/dog2.png")},
                            {"time": 125*2, "image": require("@frog/source/assets/images/dice-tactics/dog3.png")},
                            {"time": 125*3, "image": require("@frog/source/assets/images/dice-tactics/dog4.png")},
                            {"time": 125*4, "image": require("@frog/source/assets/images/dice-tactics/dog3.png")},
                        ]
                    },
                },
                "portraits": {
                    "neutral": require("@frog/source/assets/images/dice-tactics/portraits/dog.png"),
                },
            },
            "mouse": {
                "key": "mouse",
                "title": "The Mousekateer",
                "affiliation": "good",
                "isRecruited": true,

                "maxhealth": 50,
                "moverange": 2,
                "armor": 10,
                "maxarmor": 10,

                "diceFaces": {
                    "0": {...items["icicle-lance"], "power": 20},
                    "1": {...items["icicle-lance"], "power": 20},
                    "2": {...items["icicle-lance"], "power": 10},
                    "3": {...items["flaming-crossbow"], "power": 10},
                    "4": {...items["flaming-crossbow"], "power": 10},
                    "5": {...items["flaming-crossbow"], "power": 20},
                },
                // "icon": require("@frog/source/assets/images/dice-tactics/actions/cancel.png")

                "stack": 1,
                "spriteSize": "4x3",
                "sprites": {
                    "idle": {
                        "frames": [
                            {"time": 0.000, "image": require("@frog/source/assets/images/dice-tactics/mouse1.png")},
                            {"time": 125*1, "image": require("@frog/source/assets/images/dice-tactics/mouse2.png")},
                            {"time": 125*2, "image": require("@frog/source/assets/images/dice-tactics/mouse3.png")},
                            {"time": 125*3, "image": require("@frog/source/assets/images/dice-tactics/mouse4.png")},
                            {"time": 125*4, "image": require("@frog/source/assets/images/dice-tactics/mouse3.png")},
                        ]
                    },
                },
                "portraits": {
                    "neutral": require("@frog/source/assets/images/dice-tactics/portraits/mouse.png"),
                },
            },
            "frog": {
                "key": "frog",
                "title": "The Banjtoad",
                "affiliation": "good",
                // "isRecruited": true,
                "isRecruited": false,

                "maxhealth": 50,
                "moverange": 2,

                "diceFaces": {
                    "0": {...items["banjo"]},
                    "1": {...items["banjo"]},
                    "2": {...items["banjo"]},
                    "3": {...items["bubble-wand"], "power": 20},
                    "4": {...items["bubble-wand"], "power": 20},
                    "5": {...items["bubble-wand"], "power": 10},
                },

                "stack": 1,
                "spriteSize": "4x3",
                "sprites": {
                    "idle": {
                        "frames": [
                            {"time": 0.000, "image": require("@frog/source/assets/images/dice-tactics/frog1.png")},
                            {"time": 125*1, "image": require("@frog/source/assets/images/dice-tactics/frog2.png")},
                            {"time": 125*2, "image": require("@frog/source/assets/images/dice-tactics/frog3.png")},
                            {"time": 125*3, "image": require("@frog/source/assets/images/dice-tactics/frog4.png")},
                            {"time": 125*4, "image": require("@frog/source/assets/images/dice-tactics/frog3.png")},
                        ]
                    },
                },
                "portraits": {
                    "neutral": require("@frog/source/assets/images/dice-tactics/portraits/frog.png"),
                },
            },
        },
    },
}
